// eslint-disable-next-line import/no-anonymous-default-export
export default {
  sessionExpired: 'Your session has expired. Please login again.',
  loginRequired: 'You must login to access this page.',
  unauthorized: 'You are not authorized for this action.',
  loginSuccess: 'Login successful',
  logoutSuccess: 'Logout successful',
  logout: 'Logout'
};
